import createActionTypes from 'utils/createActionTypes'

export default createActionTypes('registration', ['CHANGE_STEP', 'RESET'])
